"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOverlay = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render loading overlay which blurs the content.
 */
const LoadingOverlay = ({
  loading
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!loading) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.OfferLoading),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {})
  });
};
exports.LoadingOverlay = LoadingOverlay;